import React, { useMemo } from 'react'

import { Table } from '../../../../../components/pdf/Table'
import { TableRowLabelValue } from '../../../../../components/pdf/TableHelpers'
import Separator from '../../../../../components/pdf/Separator'
import Text from '../../../../../components/pdf/Text'
import View from '../../../../../components/pdf/View'
import {
  getReplyValue,
  findReplyByQuestionName,
  getPlaceNames,
  getAddressValue,
  getDate,
  totalEmployees
} from '../../_helpers/pdfHelpers'

const CompanyInfoSection = ({ serviceOrder }) => {
  const isPAB = useMemo(() => {
    return getReplyValue(findReplyByQuestionName(serviceOrder.replies, 'QUAL TIPO?')) === 'PAB (POSTO DE ATENDIMENTO)'
  }, [serviceOrder.replies])

  const placeNames = getPlaceNames(serviceOrder.place.name)

  return (
    <View pageBreakAfter id="1">
      <Separator weight={15} />
      <View pageBreakAfter>
        <Text bold size="small">
          1. INFORMAÇÕES INICIAIS
        </Text>
        <Separator weight={5} />
        <Text bold size="small">
          1.1 IDENTIFICAÇÃO DA EMPRESA
        </Text>
        <Separator weight={8} />

        <Table width="100%">
          <TableRowLabelValue label="Razão Social" value="Unimed" colSpan={2} />
          <TableRowLabelValue label="CNPJ" value={'00.000.000/0001-00'} colSpan={2} />
          <TableRowLabelValue
            label="Endereço"
            value={'Alameda Vicente Pinzon, 54 - 5º andar - Vila Olímpia, São Paulo - SP, 04547-130'}
            colSpan={2}
          />
          <TableRowLabelValue label="CNAE" value="6550-2" colSpan={2} />
          <TableRowLabelValue label="Ramo de Atividade" value="Planos de Saúde" colSpan={2} />
          <TableRowLabelValue label="Grau de Risco" value="01" colSpan={2} />

          <TableRowLabelValue
            label="RESPONSÁVEL PELO PGR NA EMPRESA"
            value="9999-9999 - Bruno D’Attilio rhsegurancatrabalho@unimed.com.br"
            colSpan={2}
          />
        </Table>

        <Separator weight={15} />

        <Text bold size="small">
          1.2. IDENTIFICAÇÃO DOS RESPONSÁVEIS PELO PROGRAMA E VISTORIA
        </Text>

        <Separator weight={8} />

        <Table width="100%">
          <TableRowLabelValue
            label="Responsável pela implementação do PGR da empresa no local"
            value={findReplyByQuestionName(serviceOrder.replies, 'Representante da empresa').value.name}
          />
          <TableRowLabelValue label="Cargo" value="Gerente de unidade" />
          <TableRowLabelValue label="Resp.Revisão Técnica Documento" value={'Bruno D’Attilio'} />
          <TableRowLabelValue label="Cargo" value={'Engenheiro de Segurança do Trabalho'} />
          <TableRowLabelValue label="Número de CREA" value={'12345678'} />
          <TableRowLabelValue label="E-mail / Telefone" value="controle.unimed@templatesso.com.br / (11) 9999-9999" />
          <TableRowLabelValue label="Resp. Técnica Unimed" value="Bruno D’Attilio" />
          <TableRowLabelValue label="Cargo" value="Engenheira de Segurança do Trabalho" />
          <TableRowLabelValue label="E-mail" value="btime@unimed.com.br" />
          <TableRowLabelValue label="Número de Registro" value="CREA: 123456789-SP" />
        </Table>
      </View>
      <Separator weight={15} />

      <Text bold size="small">
        1.3. IDENTIFICAÇÃO DA UNIDADE
      </Text>

      <Separator weight={8} />
      <Table width="100%">
        <TableRowLabelValue label="Uniorg" value={placeNames.placeCode} />
        <TableRowLabelValue label="Nome da Agência" value={placeNames.placeName} />
        <TableRowLabelValue label="CNPJ" value={'00.000.000/0001-00'} />
        <TableRowLabelValue label="Descrição da atividade do Estabelecimento" value={'Planos de Saúde'} />
        <TableRowLabelValue
          label="Endereço"
          value={'Alameda Vicente Pinzon, 54 - 5º andar - Vila Olímpia, São Paulo - SP, 04547-130'}
        />
        <TableRowLabelValue
          label="Telefone (s) para contato"
          value={getReplyValue(findReplyByQuestionName(serviceOrder.replies, 'TELEFONE DA AGENCIA'))}
        />
        <TableRowLabelValue
          label="Horário de funcionamento"
          value={findReplyByQuestionName(serviceOrder.replies, 'JORNADA DIÁRIA')
            .value.map(e => e.name)
            .join(' ')}
        />
        <TableRowLabelValue
          label="Número de empregados da empresa no posto de trabalho"
          value={totalEmployees(serviceOrder.replies)}
        />
      </Table>

      <Separator weight={15} />

      {isPAB && (
        <>
          <Text bold size="small">
            1.4. IDENTIFICAÇÃO DA EMPRESA CONTRATANTE (Quando for PAB)
          </Text>

          <Separator weight={8} />
          <Table width="100%">
            <TableRowLabelValue label="Unidade/Projeto/Contrato" value={'xxxx'} />
            <TableRowLabelValue
              label="Razão Social da contratante"
              value={getReplyValue(
                findReplyByQuestionName(serviceOrder.replies, 'RAZÃO SOCIAL (DA EMPRESA ONDE O PAB ESTÁ LOCALIZADO)')
              )}
            />
            <TableRowLabelValue label="CNPJ" value={'00.000.000/0001-00'} />
            <TableRowLabelValue
              label="CNAE"
              value={getReplyValue(
                findReplyByQuestionName(serviceOrder.replies, 'CNAE (DA EMPRESA ONDE O PAB ESTÁ LOCALIZADO)')
              )}
            />
            <TableRowLabelValue
              label="Atividade principal"
              value={getReplyValue(
                findReplyByQuestionName(
                  serviceOrder.replies,
                  'ATIVIDADE PRINCIPAL (DA EMPRESA ONDE O PAB ESTÁ LOCALIZADO)'
                )
              )}
            />
            <TableRowLabelValue
              label="Grau de risco"
              value={getReplyValue(
                findReplyByQuestionName(serviceOrder.replies, 'GRAU DE RISCO (DA EMPRESA ONDE O PAB ESTÁ LOCALIZADO)')
              )}
            />
          </Table>

          <Separator weight={15} />
        </>
      )}

      <Text bold size="small">
        1.{isPAB ? '5' : '4'}. DADOS DA VISITA TÉCNICA
      </Text>

      <Separator weight={8} />
      <Table width="100%">
        <TableRowLabelValue label="Data da visita técnica" value={getDate(serviceOrder.endDate)} />
        <TableRowLabelValue label="Resp. pela realização da visita técnica" value={serviceOrder.user.name} />
      </Table>

      <Separator weight={15} />
    </View>
  )
}

export default CompanyInfoSection
